import type { TFunction } from "i18next";

export interface FormattedHours {
  /** The number part, e.g. "29" or "1.2k". */
  value: string;
  /** The unit part, pluralised: "hr" / "hrs" (per locale). */
  unit: string;
}

const THOUSAND = 1000;

/**
 * Saved-hours display used by the Time Savings card and its breakdown table:
 * "1 hr", "0 hrs", "29 hrs", and from a thousand up "1.2k hrs" (one decimal,
 * trailing .0 dropped, so 1000 -> "1k hrs"). Anything that is not a finite,
 * non-negative number counts as 0.
 */
export const formatSavedHours = (hours: number | null | undefined, t: TFunction): FormattedHours => {
  const safe = typeof hours === "number" && Number.isFinite(hours) && hours > 0 ? hours : 0;
  const whole = Math.round(safe);

  if (whole >= THOUSAND) {
    const thousands = (whole / THOUSAND).toFixed(1).replace(/\.0$/, "");
    return { value: `${thousands}k`, unit: t("dashboard.savings.hours", { count: whole }) };
  }

  return { value: whole.toLocaleString(), unit: t("dashboard.savings.hours", { count: whole }) };
};
